import VisionGround from "../assets/images/visionground.png"
import { Link } from "react-router-dom";
import Footer from "../components/footer";

export default function Vision () {
    return (
        <div class="w-full sm:w-1/3">
            <div class="w-full mt-8 flex flex-row justify-around">
               <div class="text-4xl w-5/12">
                   <p>horsey</p>
               </div>
               <Link class="w-3/12 rounded pt-1 h-8 bg-blue-700" to="/beforeSignUp">
               <div class="w-full text-white text-center font-light">
                   <p>Sign In</p>
               </div>
               </Link>
           </div>
           <div class="w-full mb-4 flex">
            <div class="w-4/12"></div>
            <div class="w-3/12">
                <p>beta</p>
            </div>
           </div>
           <div class="h-4 w-full"/>
            <div class="pl-8 text-3xl my-4 dtwo">VISION</div>
            <div class="my-12 flex"><img class="w-full" src={VisionGround} /></div>
            <div class="flex mb-12"><div class="m-auto w-10/12 text-lg">We establish in each college a business studio which is run by students where the lead student each year is the most skilled entrepreneur in their college.</div></div>
            <div class="mx-7 my-2">A business studio will only succeed if it’s leadership is highly sort by the incoming companies as that would encourage students to helm these roles. </div>
            <div class="mx-7 my-2">You may say that if that person is so skilled, why don’t they start there own venture. I did not say that starting your own venture is not possible, it’s a choice. But we do not want that the person to lose the choice of having a career.</div>
            <div class="mx-7 my-2">I want that as companies are always starting new ventures, they should find our lead students as the most apt candidates with demonstrable skill and ability to see the world better than their peers.</div>
            <div class="mx-7 my-2">These students with vision are to become leaders, and this is what is most important to us as an outcome of this business studio incorporation.</div>
            <div class="mx-7 my-2">The leads will work on variety of student ideas so that any student who needs support in diverse aspects of their venture, find that support.</div>
            <div class="mx-7 my-2">The so formed ventures will be the hard work and future of students. Those who lead will learn the ability to judge ideas, recognise different challenges in ideas, see failed and successful attempts and carry this know-how as they develop entrepreneurial skills and mindset.</div>
            <div class="mx-7 my-2">The second part is formalisation of work and production of digital assets which automate the business studio making them self - sufficient in helping students. All these services will have subscriptions which will be used to support the business studio’s network expansion and salaries for the lead students.</div>
            <div class="mx-7 my-2">I will also earn from this only and maybe in high amounts in the future, but we will try to create a council to manage that if needed in the future.</div>
            <div class="h-16"></div>
            <Footer/>
        </div>  
    );
}